<template>
    <div class="mt20">
        <Passenger ref="carrierComponent" :disabledRightArea="true" />

        <div
            class="md-layout-item md-large-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
        >
            <div class="hr" />
            <md-card-header class="db">
                <md-card-header-text>
                    <div class="md-layout-item md-subhead  md-xsmall-size-100">
                        <h2 class="uppercase light f14">
                            <div v-html="$t('waitingRoom.searchEngine')" />
                        </h2>
                        <small class="c9c9c9c">{{ date }} {{ time }}</small>
                    </div>
                </md-card-header-text>
            </md-card-header>

            <autocomplete-form
                ref="autocomplete"
                :isSpectrum="true"
                :depositButton="false"
                :routeDetails="{}"
                @response="
                    e => {
                        searchResultsArray = e;
                    }
                "
                @destination="destination"
            />

            <div
                v-for="(item, index) in searchResultsArray"
                :key="'abcd-' + item.user_id"
            >
                <item-of-listCarrier
                    :isSpectrum="true"
                    :item="item.userVoip"
                    :enabledStatus="false"
                    :enabledCall="false"
                    :enabledItem="true"
                    :index="index"
                    :from="from"
                    :to="to"
                />
            </div>

            <tips class="pl16 pr16 pb16" style="padding-top:16px;" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Passenger from '../components/Passenger';
import AutocompleteForm from '../components/AutocompleteForm';
import Tips from '../components/Tips';
import ItemOfListCarrier from '../components/ItemOfListCarrier';

export default {
    components: {
        Passenger,
        AutocompleteForm,
        Tips,
        ItemOfListCarrier
    },

    data() {
        return {
            time: '',
            date: '',
            searchResultsArray: [],
            canUpdateTime: true,
            from: '',
            to: ''
        };
    },

    computed: {
        ...mapGetters({
            loggedIn: 'auth/loggedInAsPassenger'
        })
    },

    methods: {
        ...mapActions({
            getPassenger: 'auth/validatePassengerToken'
        }),

        destination(e) {
            const { from, to } = e;
            this.from = from;
            this.to = to;
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        updateTime() {
            var cd = new Date();
            this.time =
                this.zeroPadding(cd.getHours(), 2) +
                ':' +
                this.zeroPadding(cd.getMinutes(), 2);
            this.date =
                this.zeroPadding(cd.getDate(), 2) +
                '.' +
                this.zeroPadding(cd.getMonth() + 1, 2) +
                '.' +
                this.zeroPadding(cd.getFullYear(), 4);
        },

        zeroPadding(num, digit) {
            var zero = '';
            for (var i = 0; i < digit; i++) {
                zero += '0';
            }
            return (zero + num).slice(-digit);
        }
    },

    async mounted() {
        window.history.pushState({}, document.title,'/passenger/spectrum');

        // await this.getPassenger();
        this.scrollToTop();

        setInterval(this.canUpdateTime ? '' : this.updateTime, 1000);
        this.updateTime();
    }
};
</script>

<style scoped>
.md-card-header {
    padding-bottom: 0 !important;
}
</style>
